import { QrCode } from "lucide-react";

export const BrandMark = ({ className = "" }) => (
  <div
    className={`relative flex flex-col items-center justify-center rounded-2xl overflow-hidden shadow-lg ${className}`}
    style={{ width: 44, height: 44 }}
    data-testid="brand-mark"
  >
    <div className="absolute inset-0 bg-brand-blue" />
    <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-brand-orange" />
    <div className="relative z-10 flex h-full w-full items-center justify-center">
      <div className="rounded-md bg-white p-1">
        <QrCode className="h-5 w-5 text-brand-navy" strokeWidth={2.4} />
      </div>
    </div>
  </div>
);

export const BrandLogo = ({ className = "", showMark = true, dark = false }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    {showMark && <BrandMark />}
    <span className="font-heading font-extrabold text-xl tracking-tight leading-none">
      <span className="text-brand-blue">Reach</span>
      <span className={dark ? "text-white" : "text-brand-navy"}>Me</span>
      <span className="text-brand-orange">Now</span>
    </span>
  </div>
);
